module.exports = __webpack_public_path__ + "img/3.829315f5.gif";